import { styled } from "goober";

// The 2px vertical margins pad the 8px pill to a 12px margin box, so ghost
// rows occupy exactly the 12px line-height of the text-small rows they mimic.
export const GhostPill = styled("span")`
  height: 8px;
  margin: 2px 0;
  border-radius: 999px;
  background: var(--alpha8);
  flex-shrink: 0;
`;
